module.exports = __webpack_public_path__ + "img/DUPLIO6.5fb97b51.png";